export const webSocket = new WebSocket('wss://webis.lingea.cz/ws/' + $("body").data("ux"));
//export const webSocket = new WebSocket('ws://localhost:3000/' + $("body").data("ux"));

export var fav_iconID=0;

var notID;
var image_counter = 0;
var favicon_images = [
  '/images/anim_icon/icon1.gif',
  '/images/anim_icon/icon3.gif'
];

$(document).on('removed.lte.cardwidget', '.chat-window', function () {
  naja.makeRequest('GET', $(this).data('close'), {'id': '0'}, {history: false})
          .then((payload) => {
            $("#chat-card-" + payload.id).remove();
          })
          .catch((error) => {
            console.log(error);
          });
});
$(document).on("change", ".chat-send-file", function (e) {
  var main = $(this).parents(".chat-window").find(".direct-chat-messages");
  var input = $(this)[0];
  var images = ",.jpg,.jpeg,.bmp,.gif,.png";
  if (input.files && input.files[0]) {
    const div = document.createElement("div");
    div.classList.add("img-chat");
    main.append(div);
    for (var i = 0; i < input.files.length; i++) {
      var file = input.files[i];
      var pos = file.name.indexOf(".") + 1;
      var ext = file.name.substr(pos);
      if (file.size > 15000000) {
        alert(file.name + " is too big. Just 15M is allowed.");
        return false;
      }

      if (images.indexOf(ext) !== -1) {
        let reader = new FileReader();
        reader.onload = function (e) {
          var image = new Image();
          image.src = reader.result;
          image.onload = function () {
            var img = document.createElement("img");
            img.src = e.target.result;
            div.append(img);
            var scroll = eval(main.prop('scrollHeight')) + image.height / 100 * 30;
            main.scrollTop(scroll);
          };
        }
        reader.readAsDataURL(file);
      } else {
        div.insertAdjacentHTML('beforeend', '<p class="chat-link"><i class="far fa-file"></i> ' + file.name + '</p>');
        var scroll = eval(main.prop('scrollHeight')) + 30 * 1;
        main.scrollTop(scroll);
      }
    }
  }
});


$(document).on("keyup", '.chat-mesasge', function (e) {
  if ($.trim($(this).val()) !== '' || $(this).parents(".chat-window").find(".img-chat").length > 0) {
    var code = e.keyCode || e.which;
    if (code === 13 && !e.shiftKey) {
      $(this).parents(".chat-text").addClass("process");

      var main = $(this).parents(".chat-window").find(".direct-chat-messages");
      var chatTo = $(this).parents('form').find(".users_to_id").val();
      var chatFrom = $(this).parents('form').find(".users_from_id").val();
      var chatName = $.trim($("#user-name-label").text());
      //console.log(detail);
      var form = $("#frm-chat-" + chatTo + "-chatForm")[0];
      console.log("#frm-chat-" + chatTo + "-chatForm");
      naja.makeRequest('POST', location.href, new FormData(form), {history: false})
              .then((payload) => {
                if (!webSocket) {
                  alert("Chat Server not connected!");
                } else {
                  var data = {'type': payload.type, 'message': $.trim($(this).val()), 'to': chatTo, 'from': chatFrom, 'users': payload.users, 'files': payload.files, 'name': chatName};
                  //$(this).val('');
                  webSocket.send(JSON.stringify(data));
                  main.find(">.img-chat").remove();
                  $("#chat-mess-" + data.to).append(payload.chat);
                  $('#chat-mess-' + data.to).scrollTop($('#chat-mess-' + data.to).prop('scrollHeight'));
                  form.reset();
                  main.find(".div-chat-answer").remove();
                }
                $(this).parents(".chat-text").removeClass("process");
              })
              .catch((error) => {
                console.log(error);
              });
      return false;
    }
    if ($(this).val().length > 50 && !$(this).parents(".chat-window").hasClass('more')) {
      $(this).parents(".chat-window").addClass("more");
      var el = $(this).parents(".chat-window").find(".direct-chat-messages")[0];
      el.scrollTop = el.scrollHeight;
    }
    if ($(this).val().length < 50 && $(this).parents(".chat-window").hasClass('more')) {
      $(this).parents(".chat-window").removeClass("more");
      var el = $(this).parents(".chat-window").find(".direct-chat-messages")[0];
      el.scrollTop = el.scrollHeight;
    }

  }
});

webSocket.onopen = (event) => {
  console.log('connection is open!');
  if ($.cookie('login')) {
    if (!webSocket) {
      alert("Chat Server not connected!");
    } else {
      data = JSON.parse($.cookie('login'));
      var data = {'type': 'login', 'id': data.id, 'login_type': data.login_type, 'online': data.online, 'mode': data.mode};
      webSocket.send(JSON.stringify(data));
      $.removeCookie('login');
    }
  }
}

webSocket.onmessage = (event) => {
  var data = JSON.parse(event.data);
  console.log(data);
  switch (data.type) {
    case "chat":
      var chat = $("#frm-chat-" + data.from + "-chatForm-text");
      if (!chat.is(":focus")) {
        if ($("#sumChat").text() === '') {
          $("#sumChat").text('1');
        } else {
          $("#sumChat").text(eval($("#sumChat").text()) + 1);
        }
      }
      if (!$.cookie('messCount-' + data.from)) {
        $.cookie('messCount-' + data.from, 1, {expires: 360, path: '/'});
        $(".messCount-" + data.from).text(1);
      } else {
        $.cookie('messCount-' + data.from, $.cookie('messCount-' + data.from) * 1 + 1, {expires: 360, path: '/'});
        $(".messCount-" + data.from).text($(".messCount-" + data.from).text() * 1 + 1);
      }
      /*
       if ($(".messCount-" + data.from).length > 0) {
       if ($(".messCount-" + data.from).text() === '') {
       $(".messCount-" + data.from).text(1);
       } else {
       $(".messCount-" + data.from).text($(".messCount-" + data.from).text() * 1 + 1);
       }
       }
       */

      if ($(".chat-detail").length > 0) {
        var source = {
          ["id"]: data.from,
          ["text"]: data.message,
          ["files"]: data.files,
          ["type"]: 'chat'
        };
      } else {
        var source = {
          ["chat-" + data.from + "-id"]: data.from,
          ["chat-" + data.from + "-text"]: data.message,
          ["chat-" + data.from + "-files"]: data.files,
          ["chat-" + data.from + "-type"]: 'chat'
        };
      }

      if ($("#chat-card-" + data.from).length > 0) {
        naja.makeRequest('GET', $("#chat-card-" + data.from).data('last'), source, {history: false})
                .then((payload) => {
                  $("#chat-mess-" + data.from).append(payload.chat);
                  $('#chat-mess-' + data.from).scrollTop($('#chat-mess-' + data.from).prop('scrollHeight'));
                })
                .catch((error) => {
                  console.log(error);
                });
      }
      notID = notifyMe(data.name, data.message, true);
      break;
    case "group":
      var chat = $("#frm-chat-" + data.to + "-chatForm-text");
      if (!chat.is(":focus")) {
        if ($("#sumChat").text() === '') {
          $("#sumChat").text('1');
        } else {
          $("#sumChat").text(eval($("#sumChat").text()) + 1);
        }
      }
      if (!$.cookie('messCount-' + data.to)) {
        $.cookie('messCount-' + data.to, 1, {expires: 360, path: '/'});
        $(".messCount-" + data.to).text(1);
      } else {
        $.cookie('messCount-' + data.to, $.cookie('messCount-' + data.to) * 1 + 1, {expires: 360, path: '/'});
        $(".messCount-" + data.to).text($(".messCount-" + data.to).text() * 1 + 1);
      }
      /*
      if ($("#messCount-" + data.to).length > 0) {
        if ($("#messCount-" + data.to).text() === '') {
          $("#messCount-" + data.to).text(1);
        } else {
          $("#messCount-" + data.to).text($("#messCount-" + data.to).text() * 1 + 1);
        }
      }
      */
     
      if ($(".chat-detail").length > 0) {
        var source = {
          ["gid"]: data.from,
          ["text"]: data.message,
          ["files"]: data.files,
          ["type"]: 'group',
          ["users"]: data.users
        };
      } else {
        var source = {
          ["chat-" + data.to + "-id"]: data.from,
          ["chat-" + data.to + "-text"]: data.message,
          ["chat-" + data.to + "-files"]: data.files,
          ["chat-" + data.to + "-type"]: 'group',
          ["chat-" + data.to + "-users"]: data.users
        };
      }
      naja.makeRequest('GET', $("#chat-card-" + data.to).data('last'), source, {history: false})
              .then((payload) => {
                $("#chat-mess-" + data.to).append(payload.chat);
                $('#chat-mess-' + data.to).scrollTop($('#chat-mess-' + data.to).prop('scrollHeight'));
                notID = notifyMe(payload.name, data.message, true);
              })
              .catch((error) => {
                console.log(error);
              });
      break;
    case "login":
      if (data.mode == 1) {
        $(".user-status-" + data.id).removeClass().addClass('user-status-' + data.id + ' user-status user-status-view');
      } else if (data.online > 0) {
        $(".user-status-" + data.id).removeClass().addClass('user-status-' + data.id + ' user-status user-status-' + data.online + '-' + data.login_type);
      } else {
        $(".user-status-" + data.id).removeClass().addClass('user-status-' + data.id + ' user-status user-status-9');
      }
      break;
    case "notice":
      if ($("#sumNotice").text() === '') {
        $("#sumNotice").text('1');
      } else {
        $("#sumNotice").text(eval($("#sumNotice").text()) + 1);
      }
      naja.makeRequest('GET', location.href, {'do': 'showNoticeList'}, {history: false})
              .then((payload) => {
              })
              .catch((error) => {
                console.log(error);
              });
      break;
  }
};

function notifyMe(title, text, mode) {
  "use strict";
  console.log("notify");
  favicon();
  if (!("Notification" in window)) {
    alert("This browser does not support system notifications");
    return 0;
  } else if (Notification.permission === "granted") {
    var ret = new Notification(title, {body: text, icon: '', renotify: 'true', tag: 'not_tag'});
    if (mode) {
      var audio = new Audio("/_files/alert.wav");
      console.log(audio.muted);
      audio.play();
    }
    return ret;
  } else if (Notification.permission !== 'denied') {
    Notification.requestPermission(function (permission) {
      if (permission === "granted") {
        var ret = new Notification("Hi there!");
        ret.close.bind();
      }
    });
    return ret;
  } else {
    console.log("Cant notify: " + Notification.permission);
  }  
}

function favicon() {    
  fav_iconID = setInterval(function() {            
    $("link[rel='icon']").attr('href','http://www.w8.cz/'+favicon_images[image_counter]);    
    if(image_counter == favicon_images.length-1) {
      image_counter=0;
    }
    else {
      image_counter = image_counter + 1;
    }        
  }, 4000);
}
